import { render, staticRenderFns } from "./CRMHistoryList.vue?vue&type=template&id=8d83d19a"
import script from "./CRMHistoryList.vue?vue&type=script&lang=js"
export * from "./CRMHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports